import Vue from "vue";
import VueRouter from "vue-router";

import { getInstance } from "../auth";
import store from "../store";
import ProfileService from "../services/ProfileService";

import Profile from "../pages/Profile.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Profile",
    component: Profile,
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// Global Before Guard
router.beforeEach(async (to, from, next) => {
  const authService = getInstance();

  const fn = async () => {
    if (authService.isAuthenticated) {
      if (!store.state.currentProfile) {
        const profile = await ProfileService.getProfile();
        store.commit("setCurrentProfile", profile);
      }

      return next();
    }

    authService.loginWithRedirect({
      appState: {
        path: to.fullPath,
        query: to.query,
      },
    });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", (loading) => {
    if (loading === false) {
      return fn();
    }
  });
});

export default router;
